export default __webpack_public_path__ + "static/media/brewery_768.269bb0df.webp";